﻿/*---[ ESLint ]---*/
/*
    global capcodes
*/

window.capcodes = function () {

    var LABEL_YES = "";
    var LABEL_NO = "";
    var LABEL_DELETE = "";

    return {

        initialize: function (labelYes, labelNo, labelDelete) {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Capcodes/Add");
            });

            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
        },


        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // dataItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Edit mode form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Capcodes/Show?capcode=" + dataItem.Capcode + "&breadcrumbLabel=" + escape(dataItem.Capcode));
        },


        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // dataItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Edit mode form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Capcodes/Edit?capcode=" + dataItem.Capcode + "&breadcrumbLabel=" + escape(dataItem.Capcode));
        },


        deleteItem: function (e) {
            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));
                capcodes.deleteCapcode(dataItem.Capcode);
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });

        },


        deleteCapcode: function (capcode) {

            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Capcodes/DeleteCapcode?capcode=" + capcode),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    navigation.navigateToSpecificUrl("Capcodes/Overview");
                }
            });
        },

    }

}();
